import { QuestionIdentifier } from '@sparemin/api-sdk';
import { createSelector } from 'reselect';

import { State } from 'redux/types';
import { isNotEnterpriseApiSelector } from '../pricing';
import { SurveyState } from './types';

const stateSelector = (state: State): SurveyState => state.get('survey');

export const surveyDataSelector = createSelector(
  stateSelector,
  state => state.data,
);

export const surveyStatusSelector = createSelector(
  stateSelector,
  state => state.status,
);

export const isPodcasterSelector = createSelector(
  surveyDataSelector,
  surveyData => surveyData && surveyData[QuestionIdentifier.PODCAST] === 'yes',
);

export const hasAnsweredSurveySelector = createSelector(
  [surveyStatusSelector, isNotEnterpriseApiSelector],
  (surveyStatus, isNotEnterprise) =>
    surveyStatus === undefined || isNotEnterprise === undefined
      ? undefined
      : !isNotEnterprise || surveyStatus === 'completed',
);
